<template>
  <div class="chat-container">
    <div class="header-chat">
      <p class="m-0 fw-bold">Constructora Bolívar</p>
      <div class="div-estamos-online">
        <span class="me-2 rounded-circle"
          style="width: 10px; height: 10px; display: inline-block; background-color: #F0D264;"></span>
        <p class="m-0">Estamos en línea</p>
      </div>
    </div>
    <div class="messages-area">
      <b-modal id="popup-modal" :title=mensajePopUp.titulo>
        <p class="my-4">{{ mensajePopUp.contenido }}</p>
      </b-modal>
      <b-card class="chat-card">
        <div v-if="!loading" class="messages-container">
          <ul class="messages-list" ref="messagesArea">
            <li v-for="(mensaje, index) in chats[chatSeleccionado].mensajes" :key="index"
              :class="{ 'message-user': mensaje.role === 'user', 'message-assistant': mensaje.role === 'assistant' }">
              <MessageElement :mensaje="mensaje" :index="index" />
            </li>
            <li v-if="escribiendo">
              <TypingIndicator />
            </li>
          </ul>
        </div>
      </b-card>
    </div>
    <AreaMensaje @sendMessage="sendMessage" :bloqueado="validando" />
  </div>
</template>

<script>
import MessageElement from '@/components/MessageElement.vue';
import TypingIndicator from '@/components/TypingIndicator.vue';
import AreaMensaje from '@/components/AreaMensaje.vue';
import io from 'socket.io-client';  // Asegúrate de importar socket.io-client
import axios from 'axios';

export default {
  components: {
    MessageElement,
    TypingIndicator,
    AreaMensaje
  },
  name: 'ChatView',
  data() {
    return {
      chats: [
        {
          Name: "Chat 1",
          mensajes: []
        }
      ],
      userId: "",
      message: null,
      chatSeleccionado: 0,
      conversationalId: null,
      tokenConversation: null,
      loading: false,
      historial: [],
      escribiendo: false,
      validando: false,
      socket: null,
      mensajePopUp: {
        titulo: "",
        contenido: ""
      }
    };
  },
  mounted() {
    this.scrollToBottom();
  },
  created() {
    localStorage.setItem('url', 'https://api-intermedia-bngffre9egffcrgm.eastus2-01.azurewebsites.net/');
    // localStorage.setItem('url', 'https://api-intermedia-test-fwb8fxcqd3a0cvg0.eastus2-01.azurewebsites.net');
    // localStorage.setItem('url', 'http://127.0.0.1:5070');
    this.socket = io(localStorage.getItem('url'), {timeout: 40000})
    this.socket.on('connect', () => {
      this.userId = this.socket.id;
      console.log("ID del usuario:", this.userId);
      console.log("Conectado al servidor WebSocket");
    });

    this.socket.on('connect_error', (error) => {
      console.error("Error al conectar al servidor WebSocket:", error);
      this.mensajePopUp.titulo = "Error de Conexión";
      this.mensajePopUp.contenido = "No se pudo conectar al servidor. Por favor, revisa tu conexión e intenta nuevamente.";
      this.$bvModal.show('popup-modal');
    });
    this.socket.on('error', (data) => {
      this.mensajePopUp.contenido = data
      this.mensajePopUp.titulo = "Error"
      this.escribiendo = false
      this.validando = false;
      this.$bvModal.show('popup-modal');
    });
    this.socket.on('respuesta', (data) => {
      let botMessage;
      if (data.datos.tipo === "texto") {
        botMessage = { role: 'assistant', content: data.datos.mensaje, tipo: data.datos.tipo };
        localStorage.setItem('id_usuario', data.datos.id_usuario || '');
        this.chats[this.chatSeleccionado].mensajes.push(botMessage);
        this.escribiendo = false;
        this.validando = false;
        this.scrollToBottom();
      } else {
        let tipo = 'image';
        if (data.datos.archivo.includes('youtu')) {
          tipo = 'youtube';
        } else if (data.datos.archivo.toLowerCase().includes('pdf')) {
          tipo = 'pdf';
        }

        const datos = {
          "url": data.datos.archivo,
          "tipo": tipo,
          "mensaje": data.datos.mensaje,
        }
        botMessage = { role: 'assistant', content: datos, tipo: data.datos.tipo };
        localStorage.setItem('id_usuario', data.datos.id_usuario || '');
        this.chats[this.chatSeleccionado].mensajes.push(botMessage);
        this.escribiendo = false;
        this.scrollToBottom();

      }
    });
  },
  methods: {
    async sendMessage(message) {
      const userMessage = { role: 'user', content: message.data, tipo: message.tipo };
      this.chats[this.chatSeleccionado].mensajes.push(userMessage);
      this.scrollToBottom();

      // Mostrar indicador de escribiendo
      this.escribiendo = true;
      this.validando = true;

      if (userMessage.tipo === 'texto') {
        // Enviar mensaje de texto al servidor por WebSocket
        const data = {
          tipoMensaje: 'texto',
          contenido: userMessage.content
        };
        this.socket.emit('mensaje', { data: data });
      } else if (userMessage.tipo === 'audio') {
        // Para mensajes de audio
        const formData = new FormData();
        let response = await fetch(userMessage.content);
        let filename = userMessage.content.split('/').pop();
        const blob = await response.blob();
        formData.append('audio', blob, filename + '.wav');

        // Convertir FormData a un objeto JSON para enviar por WebSocket
        const data = {
          tipoMensaje: 'audio',
          extencionm: "wav",
          contenido: await this.convertFormDataToBase64(formData),
        };

        this.socket.emit('mensaje', { data: data });
      } else if (userMessage.tipo === 'archivos') {
        // Para mensajes de archivos
        const archivos = [];
        for (let i = 0; i < userMessage.content.archivos.length; i++) {
          const fileObj = userMessage.content.archivos[i];
          let response = await fetch(fileObj.url);
          const blob = await response.blob();
          const base64File = await this.blobToBase64(blob);
          archivos.push({
            nombre: fileObj.nombre,
            tipo: fileObj.tipo,
            contenido: base64File,
          });
        }

        // Enviar archivos al servidor por WebSocket
        const data = {
          tipoMensaje: 'archivos',
          contenido: archivos,
          mensaje: userMessage.content.mensaje,
          id_usuario: this.userId || "ok"
        };
        console.log(data)
        try {
          let url = localStorage.getItem('url') + '/enviar_archivos';
          const response = await axios.post(url, data);
          console.log('Data sent successfully:', response);
        } catch (error) {
          console.error('Error sending data:', error);
        }
      }

      // La respuesta del bot será manejada en la función `created` que escucha el evento 'respuesta'
    },
    async convertFormDataToBase64(formData) {
      const object = {};
      for (let [key, value] of formData.entries()) {
        if (value instanceof Blob) {
          object[key] = await this.blobToBase64(value);
        } else {
          object[key] = value;
        }
      }
      return object;
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          // Eliminar el prefijo de tipo de dato
          const base64Content = base64String.split(',')[1];
          resolve(base64Content);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const element = this.$refs.messagesArea;
          element.scroll({
            top: element.scrollHeight,
            behavior: 'smooth'
          });
        })
      });
    },

  }
};
</script>

<style scoped>
/* verde #095636  #2b8b4b 00a24f*/
/* beige #EBDDB6  #504741  #efe2d9*/
/* gris #343331*/
/* blanco #FEFDF8 #FCFAF9*/
/* amarillo #f8db66 */

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #e8e8e8;
}

.messages-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.chat-card {
  height: 100%;
  background-color: #e8e8e8;
  color: white;
  border: none;
  padding: 0px;
}

.messages-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
}

.messages-list {
  list-style-type: none;
  padding: 10px;
  margin: 0;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* .message-user,
.message-assistant{
  font-size: clamp(0.95rem,1.2vw, 1.1rem);
  line-height: 1.5;
  color: #333
} */

.bubble {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 10vw;
  height: 10vw;
  max-width: 70px;
  max-height: 70px;
  min-height: 70px;
  min-width: 70px;
  border-radius: 100%;
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease, background-color 0.3s ease;
  z-index: 1000;
}

.bubble:hover {
  background-color: #ec971f;
  transform: scale(1.2);
}

.bubble-img {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
}

.bubble:hover .bubble-img {
  transform: scale(1.2);
}

@media (max-width: 100%) {
  .messages-area {
    width: 100%;
  }
}

.header-chat {
  background-color: #008C44;
  color: white;
  padding: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
}

.div-estamos-online {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
}
</style>
